<script>
export default {
  name: 'FileMixin',
  methods: {
    /**
     * 添加文件
     * @param file
     * @private
     */
    __pushFile (file, targetFolder) {
      // 添加根目录
      if (file.frontId === 'root') {
        this.nodes.push(this.buildNewFolder({ path: file.path, name: file.path, frontId: file.frontId }))
        this.__sort(this.nodes)
        return
      }
      // 指定目录
      if (targetFolder != null) {
        const templateFile = this.buildNewFile(file)
        targetFolder.children.push(templateFile)
        this.templateFiles.push(templateFile)
        this.__sort(targetFolder.children)
        return
      }
      // 未指定目录的情况下，根据文件的outputPath来动态创建目录并添加
      const folderPaths = this.parsePath(file.outputPath)
      let parentFolder = this.nodes[0]
      for (let i = 0; i < folderPaths.length; i++) {
        const fullPath = folderPaths.slice(0, i + 1).join('/')
        const path = folderPaths[i]
        let folder = this.__searchFolderByPath(this.nodes, fullPath)
        if (folder == null) {
          folder = this.buildNewFolder({ name: path, path: fullPath })
          parentFolder.children.push(folder)
        }
        parentFolder = folder
      }
      const templateFile = this.buildNewFile(file)
      parentFolder.children.push(templateFile)
      this.templateFiles.push(templateFile)
      this.__sort(this.nodes)
    },
    /**
     *  添加目录
     */
    __pushFolder (folder, parentFolder) {
      if (parentFolder == null) {
        parentFolder = this.__searchFolderByPath(this.nodes, folder.path)
      }
      if (parentFolder == null) {
        parentFolder = this.nodes[0]
      }
      parentFolder.children.push(this.buildNewFolder(folder))
      this.__sort(parentFolder.children)
    },
    // 同步文件信息
    __syncFileInfo (file) {
      // 自动推算别名
      file.alias = this.__getAliasByFileName(
        file.name,
        file.frontId
      )
      // 输出文件名表达式
      file.fileNameExp = file.name
    },
    // 同步目录下所有的文件信息
    __syncFolderFiles (folder) {
      if (folder.children == null || folder.children.length === 0) {
        return
      }
      for (const child of folder.children) {
        child.cycle = folder.cycle
        if (child.type === 'folder') {
          child.path = folder.path + '/' + child.name
        }
        if (child.type === 'file') {
          child.outputPath = folder.path
        }
        if (child.type === 'file') {
          child.__isEdited = true
        }
        if (child.type === 'folder') {
          this.__syncFolderFiles(child)
        }
      }
    },
    // 根据文件名获取别名
    __getAliasByFileName (fileName, frontId, offset) {
      if (fileName.trim().length === 0) return ''
      let alias = fileName
      while (alias.startsWith('.')) {
        alias = alias.substring(1)
      }
      while (alias.endsWith('.')) {
        alias = alias.substring(0, alias.length - 1)
      }
      alias = alias.substring(0, 1).toLowerCase() + alias.substring(1)
      if (alias.indexOf('.') > -1) {
        alias = alias.substring(0, alias.lastIndexOf('.')).trim()
      }
      if (offset != null) {
        alias = `${alias}-${offset}`
      }
      const existsFile = this.__getFileByAlias(alias)
      if (existsFile != null && existsFile.frontId !== frontId) {
        return this.__getAliasByFileName(
          fileName,
          frontId,
          offset == null ? 1 : ++offset
        )
      }
      return alias
    },
    // 根据别名获取文件
    __getFileByAlias (alias) {
      for (const tpl of this.templateFiles) {
        if (tpl.alias === alias) {
          return tpl
        }
      }
      return null
    },
    /**
     * 根据路径查找目录
     */
    __searchFolderByPath (nodes, path) {
      for (const node of nodes) {
        if (node.type !== 'folder') {
          continue
        }
        if (node.path === path) {
          return node
        }
        if (node.children.length > 0) {
          const n = this.__searchFolderByPath(node.children, path)
          if (n != null) {
            return n
          }
        }
      }
      return null
    },
    /**
     * 排序
     */
    __sort (nodes) {
      nodes = nodes.sort((item1, item2) => {
        if (item1.type === 'folder' && item2.type === 'file') {
          return -1
        }
        if (item1.type === 'file' && item2.type === 'folder') {
          return 1
        }
        return item1.name > item2.name ? 1 : -1
      })
      for (const node of nodes) {
        if (node.type === 'folder' && node.children != null && node.children.length !== 0) {
          this.__sort(node.children)
        }
      }
    }
  }
}
</script>
